var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Microsoft_logo_svg__MS-symbol",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 72 72",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f25022",
    d: "M0 0h34.2v34.2H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fba00",
    d: "M37.8 0H72v34.2H37.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a4ef",
    d: "M0 37.8h34.2V72H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb900",
    d: "M37.8 37.8H72V72H37.8z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9Ik1TLXN5bWJvbCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDcyIDcyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3MiA3MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiM3MzczNzM7fQoJLnN0MXtmaWxsOiNGMjUwMjI7fQoJLnN0MntmaWxsOiM3RkJBMDA7fQoJLnN0M3tmaWxsOiMwMEE0RUY7fQoJLnN0NHtmaWxsOiNGRkI5MDA7fQo8L3N0eWxlPgo8Zz4KCTxyZWN0IGNsYXNzPSJzdDEiIHdpZHRoPSIzNC4yIiBoZWlnaHQ9IjM0LjIiLz4KCTxyZWN0IHg9IjM3LjgiIGNsYXNzPSJzdDIiIHdpZHRoPSIzNC4yIiBoZWlnaHQ9IjM0LjIiLz4KCTxyZWN0IHk9IjM3LjgiIGNsYXNzPSJzdDMiIHdpZHRoPSIzNC4yIiBoZWlnaHQ9IjM0LjIiLz4KCTxyZWN0IHg9IjM3LjgiIHk9IjM3LjgiIGNsYXNzPSJzdDQiIHdpZHRoPSIzNC4yIiBoZWlnaHQ9IjM0LjIiLz4KPC9nPgo8L3N2Zz4K";
export { SvgMicrosoftLogo as ReactComponent };